/* ==================================================================
   THEONE — US layer
   ------------------------------------------------------------------
   Everything in this file runs ONLY for a visitor shipping to the
   United States. Every other market is untouched, byte for byte.

   A US visitor gets the American seal instead of the European one,
   and the two shipping lines that go with it. Same shape as the EU
   tile: where it ships from, then how it gets there.

        EU   seal SHIPS FROM EUROPE
             "Ships from the EU"
             "Prepared in 24 to 48h, tracked to your door in 5 to 7 days."

        US   seal SHIPS FROM MINNESOTA
             "Ships from Minnesota"
             "Packed in Minnesota and tracked to your door in 2 to 4 days."

   No customs line, no duties line. A domestic parcel never crosses a
   border, so there is nothing to reassure anyone about.

   US shipping is FREE since 9 Oct 2026 (the one US rate, "Standard",
   is 0.00 in Settings > Shipping), so the trust row says so. If a
   paid US rate ever comes back, take the word "Free" out of TRUST.

   Her rule, 9 Oct 2026: a US page must never say EU. Section 3 is
   the net: every EU shipping phrase the theme prints anywhere (the
   homepage strip, ring details, proof strip, FAQ, cart line) is
   rewritten for the US market, whatever page it sits on. When a new
   EU phrase appears in a template, add a pair to EU_TO_US.

   >>> THE SWITCH <<<
   US_LIVE below must stay false until the Minnesota 3PL has actually
   shipped its first order. Until then a US order leaves Slovenia and
   "Ships from Minnesota" would be a false origin line, which is the
   exact thing this file exists to remove. Flip it the day stock is
   on the shelf in Andover; flip it back if the 3PL ever pauses.
   ================================================================== */
(function () {
  'use strict';

  var US_LIVE = true;       /* <-- stock is in Minnesota and shipping */

  function country() {
    return (window.Shopify && window.Shopify.country) || '';
  }
  if (country() !== 'US' || !US_LIVE) return;

  var SEAL_LABEL = 'Ships from Minnesota';
  var SEAL_NOTE  = 'Packed in Minnesota and tracked to your door in 2 to 4 days.';
  var TRUST      = ['Ships from the US', 'Free tracked delivery', 'Size exchange', 'Promise Vault included'];

  /* longest phrase first, so "Ships from the EU with tracking" is not
     half-eaten by "Ships from the EU" */
  var EU_TO_US = [
    ['Orders leave the warehouse within 24 to 48 hours and ship tracked with DPD from the EU. Most arrive in 5 to 7 days.',
     'Orders ship tracked from our warehouse in Minnesota and arrive in 2 to 4 days.'],
    ['Free shipping across the EU · Tracked with DPD', 'Free shipping across the US · Tracked to your door'],
    ['Prepared in 24 to 48h, tracked to your door in 5 to 7 days.', SEAL_NOTE],
    ['Ships from the EU with tracking', 'Ships from Minnesota with tracking'],
    ['Ships from the EU', 'Ships from the US'],
    ['Tracked DPD Delivery', 'Free Tracked Delivery'],
    ['Free EU delivery', 'Free US delivery']
  ];

  /* ---------- 1. the seal tile, product page AND homepage ---------- */
  function swapSeals() {
    /* tl-ill-europe.jpg on the homepage, tl-ill-europe-t.png on the
       PDP card. One match rule covers both, and anywhere it is used
       next. */
    var imgs = document.querySelectorAll('img[src*="tl-ill-europe"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('data-tl-us')) continue;
      img.setAttribute('data-tl-us', '1');

      img.src = img.src.replace('tl-ill-europe', 'tl-ill-us');

      var tile = img.parentNode;
      if (!tile) continue;
      var label = tile.querySelector('b');
      if (label) label.textContent = SEAL_LABEL;
      var note = tile.querySelector('p');        /* homepage tile only */
      if (note) note.textContent = SEAL_NOTE;
    }
  }

  /* ---------- 2. the row under Add to Cart ---------- */
  function swapTrust() {
    var row = document.querySelector('.tl-trust');
    if (!row || row.getAttribute('data-tl-us')) return;
    row.setAttribute('data-tl-us', '1');
    row.innerHTML = '';
    for (var i = 0; i < TRUST.length; i++) {
      var item = document.createElement('span');
      item.className = 'tl-trust__item';
      var tick = document.createElement('span');
      tick.className = 'tl-trust__check';
      tick.setAttribute('aria-hidden', 'true');
      tick.textContent = '✓';
      item.appendChild(tick);
      item.appendChild(document.createTextNode(TRUST[i]));
      row.appendChild(item);
    }
  }

  /* ---------- 3. the net: no EU phrase survives on a US page ---------- */
  function swapText() {
    if (!document.body || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node, text, p, i, k, changed;
    while ((node = walker.nextNode())) {
      text = node.nodeValue;
      if (!text) continue;
      p = node.parentNode;
      if (p && (p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE' || p.nodeName === 'TEXTAREA')) continue;
      changed = false;
      for (i = 0; i < EU_TO_US.length; i++) {
        k = EU_TO_US[i][0];
        if (text.indexOf(k) !== -1) { text = text.split(k).join(EU_TO_US[i][1]); changed = true; }
      }
      if (changed) node.nodeValue = text;
    }
  }

  function run() {
    try { swapSeals(); } catch (e) {}
    try { swapTrust(); } catch (e) {}
    try { swapText(); } catch (e) {}
  }

  /* the tiles and the row are both written by theone-luxe.js after
     load, so watch for them instead of guessing at a delay */
  function boot() {
    run();
    if (!('MutationObserver' in window)) return;
    var pending = 0;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = 1;
      setTimeout(function () { pending = 0; run(); }, 40);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); run(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(run, 1400);
  setTimeout(run, 3200);
})();
